module.exports = __webpack_public_path__ + "img/twitter.c9fd5455.svg";